module.exports = __webpack_public_path__ + "img/clickfunnels_2.55c2e17b.png";